import styled, { css } from 'styled-components';

import media from '../../../../utils/styling/media';

import Row from '../../../grid/Row';

import IconButton from '../../../buttons/IconButton';

type StyledHeaderProps = {
  height?: number;
  horizontalLogo?: boolean;
  primary?: boolean;
  background?: string;
};

export const StyledHeader = styled.header<StyledHeaderProps>`
  min-height: ${({ theme, height }) => height || theme.layout.minContentHeight}px;
  height: ${({ theme, horizontalLogo }) => horizontalLogo ? theme.layout.horizontalLogoHeaderHeight : theme.layout.headerHeight}px;
  background: ${({ background }) => background};

  ${({ primary }) => primary && css`
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.primary};
  `}

  ${IconButton.StyledButton} {
    ${({ primary }) => primary && css<StyledHeaderProps>`
      color: ${({ theme }) => theme.colors.white};
      width: 56px;
      height: ${({ theme, horizontalLogo }) => horizontalLogo ? theme.layout.horizontalLogoHeaderHeight : theme.layout.headerHeight}px;
  
      &:hover {
        color: ${({ theme }) => theme.colors.white};
        background: #2062D4;
      }
    
      &[disabled], &:disabled {
        color: ${({ theme }) => theme.colors.disabled};
        cursor: default;
      }
    
      &:focus-visible, &:focus {
        filter: drop-shadow( 0 0 3px ${({ theme }) => theme.colors.focus});
      }
    
      &:focus:not(&:focus-visible) {
        filter: none;
        box-shadow: none;
      }
    
      &:active:not(:disabled)  {
        color: ${({ theme }) => theme.colors.white};
        background: #2962FF;
      }
    `}
  }
`;

export const StyledHeaderContent = styled.div<{padding: string; mdPadding: string}>`
  max-width: ${({ theme }) => theme.layout.maxHeaderContentWidth || (theme.layout.maxContentWidth + 16)}px;
  margin: 0 auto;
  height: 100%;
  padding: ${({ theme, padding }) => padding || theme.layout.headerPadding};
  box-sizing: border-box;

  ${({ mdPadding }) => mdPadding && css`
    ${media.md`
      padding: ${mdPadding};
    `}
  `}

  ${media.lg`
    padding: ${({ theme }) => theme.layout.lgHeaderPadding};
  `}
`;

export const StyledHeaderRow = styled(Row)`
  height: 100%;
  align-items: center;
`;
